import * as investOffer from './invest-offer';

export default {
    investOffer,
};
